const uploadManagerRow = {
  RETRY: 'Retry',
  FAILED: 'Failed',
  UPLOADED: 'Uploaded',
};

export default uploadManagerRow;
